export default "__VITE_ASSET__twyiIbZM__"